export const HEADER_SEARCH_UPDATE = 'HEADER_SEARCH_UPDATE'
export const HEADER_SEARCH_RESET = 'HEADER_SEARCH_RESET'
